var map = {
	"./en/informations.json": [
		63107,
		3107
	],
	"./fr/informations.json": [
		78118,
		8118
	],
	"./nl/informations.json": [
		99032,
		9032
	],
	"./zh/informations.json": [
		65616,
		5616
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 61854;
module.exports = webpackAsyncContext;